/**
 * @graphql agg
 */
import { graphql } from 'react-relay';

export const ConfluenceTransactionAccountEndOfTrialQuery = graphql`
	query ConfluenceTransactionAccountEndOfTrialQuery($cloudId: ID!, $productKey: String!) {
		tenantContexts(cloudIds: [$cloudId]) {
			entitlementInfo(hamsProductKey: $productKey) {
				entitlement {
					transactionAccount {
						isBillToPresent
						isCurrentUserBillingAdmin
					}
				}
			}
		}
	}
`;
